import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to a hash target (e.g. #packages, #lead-form) whenever the
 * route or hash changes. Works for cross-route hash links like
 * <Link to="/#packages">.
 */
const ScrollToHash = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer to next tick so the destination route has mounted its content
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 60);
      return () => clearTimeout(t);
    }
    // No hash: scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    return undefined;
  }, [hash, pathname]);

  return null;
};

export default ScrollToHash;
